import {
  Component,
  OnInit,
  Output,
  EventEmitter,
  Input,
  ViewChild,
} from "@angular/core";
import {
  FormBuilder,
  FormGroup,
  Validators,
  AbstractControl,
} from "@angular/forms";
import { FreeTrialService } from "../free-trial.service";
import { CacheCountryService } from "src/app/services/cacheCountries.service";
import { takeUntil } from "rxjs/operators";
import { Subject } from "rxjs";
import { ToastrService } from "ngx-toastr";
import { ConfirmationService } from "primeng/api";
import { Store } from "@ngrx/store";
import {
  MarkCleanFormAction,
  MarkDirtyFormAction,
} from "src/app/app-state/actions/dirty-form.actions";
import { ConfirmationModalComponent } from "src/app/modules/shared/modal/confirmation-modal/confirmation-modal.component";
import { MatDialog } from "@angular/material/dialog";
import { ActivatedRoute, Router } from "@angular/router";
import { CompanyService } from "src/app/services/company.service";
import { PageEvent } from "@angular/material/paginator";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
@Component({
  selector: "app-add-user",
  templateUrl: "./add-user.component.html",
  styleUrls: ["./add-user.component.scss"],
})
export class AddUserComponent implements OnInit {
  @Output() notify: EventEmitter<number> = new EventEmitter<number>();
  @Input() companyId;
  listCountry: [];
  newPwdValidity: boolean;
  observableSubscription$ = new Subject();
  dirtyFlag: boolean = false;
  disableFields: boolean = false;
  disableFieldsForm = false;
  userAddBtnDisabled = false;
  public creatingUserForm: FormGroup;
  public userDetails: any = [];
  rollTypeList: object[] = [];
  formChangesSubscription: any;
  confirmPwdValidity: boolean = false;
  totalRecordCount: number;
  pageSize: number;
  pageIndex: number;
  searchText = "";
  confirm_password_hide: boolean = false;
  new_password_hide: boolean = false;
  countuser: any;
  getArrayAddClientUser: any;

  constructor(
    private formBuilder: FormBuilder,
    public dialogRef: MatDialogRef<AddUserComponent>,
    protected store: Store<any>,
    public dialog: MatDialog,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private toastr: ToastrService,
    private companyService: CompanyService,
    private confirmationService: ConfirmationService,
    private cacheCountryService: CacheCountryService,
    private clientsService: FreeTrialService
  ) {
    this.activatedRoute.params.subscribe((parameter) => {
      let parameterId = null;
      if (parameter.hasOwnProperty("id")) {
        this.companyId = parameterId;
        this.companyService.getCompaniesById(parameter.id).subscribe((data) => {
        });
      } else {
      }
    });
  }

  ngOnInit() {
    this.totalRecordCount = 0;
    this.pageSize = 25;
    this.pageIndex = 1;
    this.creatingUserFormInitialize();
    this.cacheCountryService.getCountry().subscribe((data) => {
      if (data.length > 0) {
        this.listCountry = data.map((x) => {
          return {
            ...x,
            countryPhoneCode: `${x.countryCode} - ${x.phoneCode}`,
          };
        });
      }
    });

    this.getUserDetails();
    this.countuser = this.clientsService.getuserCount();
    this.getArrayAddClientUser =  this.clientsService.getattorneyUserInfoArray();
    if (this.getArrayAddClientUser.length !== 0) {
      this.userAddBtnDisabled = true;
      this.creatingUserForm.disable();
    }
  }

  ngAfterViewInit() {
    this.formChangesSubscription =
      this.creatingUserForm.statusChanges.subscribe(() => {
        if (this.creatingUserForm.dirty) {
          this.store.dispatch(
            new MarkDirtyFormAction({
              dirty: true,
            })
          );
          this.dirtyFlag = true;
        } else {
          this.store.dispatch(
            new MarkCleanFormAction({
              dirty: false,
            })
          );
          this.dirtyFlag = false;
        }
      });
  }

  getUserRoles() {
    this.rollTypeList = [];
  }

  editNewUser(data: any) {
    this.creatingUserForm.enable();
    this.userAddBtnDisabled = false;
    this.creatingUserForm.patchValue({
      id: data.id,
      firstName: data.firstName,
      lastName: data.lastName,
      middleName: data.middleName,
      email: data.email,
      countryCode: data.countryCode,
      phoneNumber: data.phone,
      password: data.password,
      confirmPassword: data.password,
    });
    this.confirmPwdValidity = true;
    let index = this.userDetails.indexOf(data);
    this.userDetails.splice(index, 1);
  }

  editNewUserNew(data: any) {

    this.creatingUserForm.enable();
    this.userAddBtnDisabled = false;
    this.creatingUserForm.patchValue({
      id: data.id,
      firstName: data.firstName,
      lastName: data.lastName,
      middleName: data.middleName,
      email: data.email,
      countryCode: data.countryCode,
      phoneNumber: data.phone,
      password: data.password,
      confirmPassword: data.password,
    });
    this.confirmPwdValidity = true;
    let index = this.getArrayAddClientUser.indexOf(data);
    this.getArrayAddClientUser.splice(index, 1);
  }

  getUserDetails() {
    let payload = {
      searchText: this.searchText,
      pageNumber: this.pageIndex,
      recordsPerPage: this.pageSize,
    };
  }

  paginationEvent(event: PageEvent) {
    this.pageIndex = event.pageIndex + 1;
    this.pageSize = event.pageSize;
    this.getUserDetails();
  }

  validateInput(type, newpwd): boolean {
    let regex: RegExp;
    if (type == "totalCount") {
      regex = /.{8,}$/;
    } else if (type == "aA3") {
      regex = /^(?=.*[a-z])(?=.*[A-Z])[a-zA-Z\S]{3,}$/g;
    } else if (type == "number") {
      regex = /^(?=.*\d)/g;
    } else if (type == "specChar") {
      regex = /^(?=.*\W)(?!.*\s)/g;
    }

    //this.setScore(newpwd.value);

    let str = newpwd.value;
    let res = str.match(regex);
    if (res) {
      return true;
    } else {
      return false;
    }
  }

  creatingUserFormInitialize() {
    this.creatingUserForm = this.formBuilder.group({
      id: [0],
      // rollType: [[]],
      firstName: ["", Validators.required],
      lastName: ["", Validators.required],
      middleName: [""],
      email: ["", Validators.required],
      countryCode: ["", Validators.required],
      phoneNumber: ["", Validators.required],
      password: ["", Validators.required],
      confirmPassword: ["", Validators.required],
    });
    // this.creatingUserForm.setValidators(this.passwordMatch);
  }

  confirmPasswordMatch() {
    if (
      this.creatingUserForm.value.password ===
      this.creatingUserForm.value.confirmPassword
    ) {
      this.confirmPwdValidity = true;
    } else {
      this.confirmPwdValidity = false;
    }
  }

  creatingUserFormSub() {
    if (this.getArrayAddClientUser) {
      this.creatingUserForm.disable();
      const payload = {
        id:
          this.creatingUserForm.controls["id"].value !== 0
            ? this.creatingUserForm.controls["id"].value
            : 0,
        countryCode: this.creatingUserForm.controls["countryCode"].value,
        email: this.creatingUserForm.controls["email"].value,
        firstName: this.creatingUserForm.controls["firstName"].value,
        lastName: this.creatingUserForm.controls["lastName"].value,
        middleName: this.creatingUserForm.controls["middleName"].value,
        phone: this.creatingUserForm.controls["phoneNumber"].value,
        password: this.creatingUserForm.controls["password"].value,
      };

      console.log("Firm info user Payload :--" + JSON.stringify(payload));
      this.getArrayAddClientUser.push(payload);
      this.store.dispatch(new MarkCleanFormAction({ dirty: false }));
      this.dirtyFlag = false;
      this.toastr.success("Info saved successfully", 'Success');
      this.clientsService.setuserInfo(payload);
      this.creatingUserForm.reset();
      this.disableFieldsForm = true;
      this.clientsService.setattorneyuserInfoarray(this.getArrayAddClientUser);
      if (this.getArrayAddClientUser.length === this.countuser) {
        this.creatingUserForm.disable();
        this.userAddBtnDisabled = true;
      }
    } else {
      this.creatingUserForm.disable();
      const payload = {
      id:
        this.creatingUserForm.controls["id"].value !== 0
          ? this.creatingUserForm.controls["id"].value
          : 0,
      countryCode: this.creatingUserForm.controls["countryCode"].value,
      email: this.creatingUserForm.controls["email"].value,
      firstName: this.creatingUserForm.controls["firstName"].value,
      lastName: this.creatingUserForm.controls["lastName"].value,
      middleName: this.creatingUserForm.controls["middleName"].value,
      phone: this.creatingUserForm.controls["phoneNumber"].value,
      password: this.creatingUserForm.controls["password"].value,
    };

      console.log("Firm info user Payload :--" + JSON.stringify(payload));
      this.userDetails.push(payload);
      this.store.dispatch(new MarkCleanFormAction({ dirty: false }));
      this.dirtyFlag = false;
      this.toastr.success("Info saved successfully", 'Success');
      this.clientsService.setuserInfo(payload);
      this.creatingUserForm.reset();
      this.disableFieldsForm = true;
      this.clientsService.setattorneyuserInfoarray(this.userDetails);
      if (this.userDetails.length === this.countuser) {
      this.creatingUserForm.disable();
      this.userAddBtnDisabled = true;
    }
  }
  }

  

  setPwdValidity(flag) {
    this.newPwdValidity = flag;
    const control = this.creatingUserForm.controls["password"];
    if (!this.newPwdValidity) {
      control.setErrors({ mustMatch: true });
      return false;
    }
  }

  confirmDelete(inputDataUser) {
    const title = "Confirm";
    const message = "Do you wish to remove this item?";
    const buttons = ["Cancel", "Delete"];

    this.dialogueInitializer(event, title, message, buttons)
      .afterClosed()
      .subscribe((result) => {
        if (result) {
          this.creatingUserForm.enable();
          this.toastr.success("User deleted successfully", 'Success');
          let index = this.userDetails.indexOf(inputDataUser);

          this.getArrayAddClientUser.splice(index, 1);
          this.userAddBtnDisabled = false;
        }
      });
  }

  dialogueInitializer(event, title: string, message: string, buttons: any[]) {
    const cordinates: MouseEventInit = event;
    const dialogRef = this.dialog.open(ConfirmationModalComponent, {
      width: "400px",
      data: {
        update: { title, message },
        buttons: buttons,
      },
    });
    return dialogRef;
  }

  
  onPrevious() {
    this.notify.emit(0);
  }

  onNext() {
    this.toastr.success("Info Update successfully", 'Success');
    this.dialogRef.close();
  }

  onCancel() {
    this.dialogRef.close(false);
  }
}
